import { __assign, __extends } from "tslib";
import React from 'react';
import { withTranslation } from 'react-i18next';
import classnames from 'classnames';
import IconButtonWithContextMenu from '../../../Dropdown/Preset/IconButtonWithContextMenu';
import EllipsisIcon from '@wix/da-ds/pkg/Icons/Ellipsis';
import TrashcanIcon from '@wix/da-ds/pkg/Icons/24x24/Trashcan';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import IconButton from '../../../Button/IconButton';
import s from './ItemControlButtons.scss';
var ItemControlButtons = /** @class */ (function (_super) {
    __extends(ItemControlButtons, _super);
    function ItemControlButtons() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ItemControlButtons.prototype.render = function () {
        var _a = this.props, t = _a.t, menuItems = _a.menuItems, withOneClickDelete = _a.withOneClickDelete, moreMenuClassName = _a.moreMenuClassName, onDelete = _a.onDelete;
        var iconProps = {
            withPadding: true,
            size: IconSize.SMALL,
        };
        return (React.createElement("div", { onClick: this.onClick, className: classnames(s['root'], this.props.className) },
            withOneClickDelete && (React.createElement(IconButton, { tooltipText: t('mediapopup.delete'), onClick: onDelete },
                React.createElement(TrashcanIcon, __assign({}, iconProps)))),
            menuItems && (React.createElement(IconButtonWithContextMenu, { contextMenuClassName: moreMenuClassName, items: menuItems, withButton: true },
                React.createElement(EllipsisIcon, __assign({}, iconProps))))));
    };
    ItemControlButtons.prototype.onClick = function (event) {
        event.stopPropagation();
    };
    return ItemControlButtons;
}(React.Component));
export { ItemControlButtons };
export default withTranslation()(ItemControlButtons);
//# sourceMappingURL=ItemControlButtons.js.map